import { getStoredManager } from '../../../hooks/useAuth';
import SectionTitle from '../SectionTitle';

export default function MyManager() {
  const manager = getStoredManager();

  if (!manager) {
    return (
      <div className="max-w-2xl">
        <div className="mb-8">
          <SectionTitle lead="Мой" accent="менеджер" />
          <p className="text-foreground-500 text-sm">Ваш персональный куратор по трудоустройству</p>
        </div>
        <div className="bg-surface-1 border border-surface-3 rounded-2xl p-8 text-center">
          <p className="text-foreground-600">Менеджер ещё не назначен</p>
        </div>
      </div>
    );
  }

  return (
    <div className="max-w-2xl">
      <div className="mb-8">
        <SectionTitle lead="Мой" accent="менеджер" />
        <p className="text-foreground-500 text-sm">Ваш персональный куратор по трудоустройству</p>
      </div>

      <div className="bg-surface-1 border border-surface-3 rounded-2xl p-8">
        <div className="flex flex-col sm:flex-row items-center sm:items-start gap-6 mb-8">
          <div className="relative flex-shrink-0">
            {manager.avatar ? (
              <img
                src={manager.avatar}
                alt={manager.name}
                className="w-24 h-24 rounded-2xl object-cover object-top"
              />
            ) : (
              <div className="w-24 h-24 rounded-2xl bg-primary-500/10 border border-primary-500/20 flex items-center justify-center">
                <i className="ri-user-line text-3xl text-primary-300" />
              </div>
            )}
            <div className="absolute -bottom-1 -right-1 w-5 h-5 bg-primary-500 rounded-full border-2 border-surface-1 flex items-center justify-center">
              <i className="ri-check-line text-[10px] text-on-primary" />
            </div>
          </div>

          <div>
            <h3 className="text-xl font-bold text-ink mb-1">{manager.name}</h3>
            <p className="text-sm text-foreground-500 mb-3">Менеджер по первичному набору</p>
            <span className="inline-flex items-center gap-1.5 text-xs bg-primary-500/10 text-primary-300 border border-primary-500/20 rounded-full px-3 py-1">
              <span className="w-3 h-3 flex items-center justify-center">
                <i className="ri-checkbox-circle-fill text-xs" />
              </span>
              На связи
            </span>
          </div>
        </div>

        <div className="space-y-3">
          <div className="flex items-center gap-4 bg-surface-2 rounded-xl px-5 py-4 hover:bg-surface-3 transition-colors">
            <div className="w-9 h-9 flex items-center justify-center rounded-xl bg-sky-500/10 flex-shrink-0">
              <i className="ri-telegram-line text-sky-400 text-lg" />
            </div>
            <div className="min-w-0">
              <p className="text-xs text-foreground-400 mb-0.5">Telegram</p>
              <a
                href={`https://t.me/${manager.telegram.replace('@', '')}`}
                target="_blank"
                rel="nofollow noopener noreferrer"
                className="text-sm text-sky-400 hover:text-sky-300 transition-colors"
              >
                {manager.telegram}
              </a>
            </div>
            <span className="ml-auto w-5 h-5 flex items-center justify-center text-foreground-400">
              <i className="ri-external-link-line text-sm" />
            </span>
          </div>

          <div className="flex items-center gap-4 bg-surface-2 rounded-xl px-5 py-4 hover:bg-surface-3 transition-colors">
            <div className="w-9 h-9 flex items-center justify-center rounded-xl bg-primary-500/10 flex-shrink-0">
              <i className="ri-mail-line text-primary-300 text-lg" />
            </div>
            <div className="min-w-0">
              <p className="text-xs text-foreground-400 mb-0.5">Email</p>
              <a
                href={`mailto:${manager.email}`}
                className="text-sm text-foreground-700 hover:text-ink transition-colors"
              >
                {manager.email}
              </a>
            </div>
            <span className="ml-auto w-5 h-5 flex items-center justify-center text-foreground-400">
              <i className="ri-external-link-line text-sm" />
            </span>
          </div>

        </div>
      </div>

      <div className="mt-4 bg-surface-1 border border-surface-3 rounded-2xl p-6">
        <div className="flex items-start gap-3">
          <span className="w-5 h-5 flex items-center justify-center text-accent-200 flex-shrink-0 mt-0.5">
            <i className="ri-lightbulb-line" />
          </span>
          <div>
            <p className="text-sm font-medium text-foreground-700 mb-1">Совет</p>
            <p className="text-sm text-foreground-500 leading-relaxed">
              По всем вопросам оформления, расписания и начала работы — обращайтесь к менеджеру
              напрямую в Telegram. Это самый быстрый способ получить ответ.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
